import authConfig from '../auth_config.json';
const { domain, clientId, authorizationParams: { audience } } = authConfig as {
  domain: string,
  clientId: string;
  authorizationParams: {
    audience?: string;
  }
}
export const environment = {
    auth: {
        domain,
        clientId,
        authorizationParams: {
        audience,
        redirect_uri: window.location.origin,
        }
    },
    // apiEndpoint: 'aHR0cHM6Ly94eGd4NGd3cGU2LmV4ZWN1dGUtYXBpLnVzLWVhc3QtMS5hbWF6b25hd3MuY29tL2FwaQ==', //https://xxgx4gwpe6.execute-api.us-east-1.amazonaws.com/api
    apiEndpoint: 'aHR0cHM6Ly93a3BjZzAzajU4LmV4ZWN1dGUtYXBpLnVzLWVhc3QtMS5hbWF6b25hd3MuY29tL2FwaQ==', //base 64 https://wkpcg03j58.execute-api.us-east-1.amazonaws.com/api

    /**
     * Lista blanca de orígenes (esquema + host + puerto) a los que la aplicación
     * puede enviar peticiones o redirigir. Se declara en texto plano y por
     * separado de `apiEndpoint` a propósito: es la referencia contra la que se
     * valida el endpoint configurado, así que no debe derivarse de él.
     * La consume UrlValidationService. Al dar de alta un ambiente nuevo, hay que
     * registrar su origen aquí de forma explícita.
     */
    apiOrigenesPermitidos: [
        'https://xxgx4gwpe6.execute-api.us-east-1.amazonaws.com',
        'https://wkpcg03j58.execute-api.us-east-1.amazonaws.com'
    ] as readonly string[]

} 